import React from "react"
import { NO_WEBP } from "../image/webp-check"
import { Content } from "../../hooks/contents"

interface SeoProps {
  selected: Content
  metaData: any
}

export const Seo = ({ selected, metaData }: SeoProps) => {
  const { metaInfos = [], siteUrl } = metaData
  const { langId } = selected
  const localizedSiteMeta = metaInfos.find((mi) => mi.langId === langId) || {}

  const baseUrl = siteUrl
  const siteTitle = localizedSiteMeta.title || ""
  const siteDescription = localizedSiteMeta.description || ""
  const socialTitle = selected.title
    ? `${selected.title} | ${siteTitle}`
    : siteTitle
  const pageTitle = selected.title
    ? `${socialTitle} | дekoder`
    : `${siteTitle} | дekoder`
  const _description = selected.description
    ? selected.description
    : siteDescription
  const description = stripTags(_description)

  const imgProps = selected.image || {
    src: localizedSiteMeta.defaultSocialImg || "",
  }
  const { src, width, height } = imgProps
  const _imgUrl = src.match(/^http/) ? src : `${baseUrl}${src}`
  const imgUrl = `${_imgUrl}?${NO_WEBP}`

  const url = selected.slug
    ? `${baseUrl}/${selected.slug}/`
    : `${baseUrl}/${langId}/`
  const type = "article"

  return (
    <>
      <html lang={langId} />
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta name="abstract" content={description} />
      <link rel="image_src" href={imgUrl} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={socialTitle} />
      <meta property="og:url" content={url} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imgUrl} />
      {!!width && <meta property="og:image:width" content={width} />}
      {!!height && <meta property="og:image:height" content={height} />}
      <meta name="twitter:title" content={socialTitle} />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imgUrl} />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="white" />
    </>
  )
}

function stripTags(str = "") {
  return str.replace(/<\/?[^>]+(>|$)/g, "")
}
